import { defaultStore } from "../../stores/defaultStore";
import { getStringSizeInMB } from "../general-utils";
import { WebServiceLayerType } from "../../stores/sidebarStore";

export const saveLayersToLocalStorage = (
  newLayers: WebServiceLayerType[],
  successMessage?: string | null,
  warningMessage?: string | null
) => {
  const changeAlertMessage = defaultStore.getState().changeAlertMessage;
  const newLayersCleaned: WebServiceLayerType[] = [];
  newLayers.forEach((layer: WebServiceLayerType) => {
    if (layer.layers && layer.layers.length > 0) {
      newLayersCleaned.push(layer);
    }
  });
  const stringifiedParsedList = JSON.stringify(newLayersCleaned);
  try {
    localStorage.setItem("layersAddedByUser", stringifiedParsedList);
    if (successMessage && changeAlertMessage) {
      changeAlertMessage({
        message: successMessage,
        type: "success",
      });
    }
  } catch (error: any) {
    if (error.name === "QuotaExceededError") {
      const allLayersSize = getStringSizeInMB(stringifiedParsedList).toString();
      if (warningMessage && changeAlertMessage) {
        changeAlertMessage({
          message: `${warningMessage} ${allLayersSize} MB / 5 MB`,
          type: "warning",
        });
      }
      console.error(
        "localstorage_quota_exceeded",
        `${allLayersSize} MB / 5 MB`
      );
    }
  }
};

export function getLayersAddedByUser(): WebServiceLayerType[] {
  const allLayersAddedFromUser: string | null =
    localStorage.getItem("layersAddedByUser");
  if (!allLayersAddedFromUser) {
    return [];
  }
  const parsedLayers = JSON.parse(allLayersAddedFromUser);
  return Array.isArray(parsedLayers) ? parsedLayers : [];
}
